import { useEffect } from 'react';

import { useUpdateNotification } from '@/features/notifications';
import { useNotificationsList } from '@/features/notifications/model/useNotificationsList';
import { Loader } from '@/shared/ui/Loader';
import { PageContainer } from '@/shared/ui/PageContainer';
import { SvgIcon } from '@/shared/ui/SvgIcon';
import { CustomTypography } from '@/shared/ui/Typography';
import { dayjs } from '@/shared/utils/dayjs';

import {
  StyledDate,
  StyledMessage,
  StyledNotifHeader,
  StyledPaper,
} from './styles';

export const NotificationsPage = () => {
  const { notifications, isPending: isLoading } = useNotificationsList();

  const {
    mutation: { mutateAsync: markAsRead },
    handleInvalidate,
  } = useUpdateNotification();

  useEffect(() => {
    const markAllAsRead = async () => {
      if (!isLoading && notifications) {
        const unreadNotifications = notifications.filter(
          (notif) => !notif.read
        );

        try {
          // Ожидаем завершения всех запросов
          await Promise.all(
            unreadNotifications.map((notif) => markAsRead(notif.id ?? ''))
          );

          // После успешного завершения всех запросов инвалидируем кэш
          handleInvalidate();
        } catch (error) {
          console.error('Error marking notifications as read:', error);
        }
      }
    };

    markAllAsRead();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, notifications]);
  return (
    <PageContainer>
      <div style={{ marginBottom: 20 }}>
        {isLoading ? (
          <Loader containerSize="medium" />
        ) : (
          notifications?.map((notification, index, arr) => (
            <StyledPaper
              key={notification.id}
              isFirst={index === 0}
              isLast={arr.length - 1 === index}
              isUnread={!!notification?.read}
            >
              <StyledNotifHeader>
                <SvgIcon
                  name="warning"
                  color={notification?.read ? 'info' : 'secondary'}
                />
                <CustomTypography fontWeight="bold">
                  {notification.title}
                </CustomTypography>
                <StyledDate>
                  <CustomTypography variant="caption" color="text.secondary">
                    {dayjs(notification.created_at).format('DD.MM.YYYY, hh:mm')}
                  </CustomTypography>
                </StyledDate>
              </StyledNotifHeader>
              <StyledMessage>{notification.content}</StyledMessage>
            </StyledPaper>
          ))
        )}
      </div>
    </PageContainer>
  );
};
